import React from "react";
import { Trash2, Plus, Upload } from "lucide-react";
import { toast } from "sonner";
import { fileToBase64 } from "@/lib/adminApi";
import { Input } from "@/components/ui/input";
import { FieldLabel, inputCls } from "@/components/admin/Fields";

export const GalleryEditor = ({ items, onChange }) => {
  const list = items || [];

  const updateCaption = (i, v) => {
    const next = [...list];
    next[i] = { ...next[i], caption: v };
    onChange(next);
  };
  const remove = (i) => {
    const next = [...list];
    next.splice(i, 1);
    onChange(next);
  };
  const addFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    for (const f of files) {
      if (f.size > 1024 * 1024) {
        toast.error(`${f.name}: must be under 1 MB. Compress first.`);
        continue;
      }
      const b64 = await fileToBase64(f);
      list.push({ id: `g${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, image: b64, caption: "" });
    }
    onChange([...list]);
    toast.message(`${files.length} image(s) loaded. Click Save to apply.`);
    e.target.value = "";
  };

  return (
    <div className="sm:col-span-2">
      <FieldLabel>Photos (max 1 MB each — JPG / PNG)</FieldLabel>
      <div className="mt-3">
        <label className="inline-flex items-center gap-2 cursor-pointer border border-[#0A2342] px-4 py-3 text-xs uppercase tracking-wider text-[#0A2342] hover:bg-[#0A2342] hover:text-white transition-colors">
          <Upload className="w-3.5 h-3.5" /> Upload photo(s)
          <input
            data-testid="admin-upload-gallery"
            type="file"
            accept="image/*"
            multiple
            className="hidden"
            onChange={addFiles}
          />
        </label>
      </div>

      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-4">
        {list.map((it, i) => (
          <div key={it.id || i} className="border border-[#E5DFD3] bg-white">
            <img
              src={it.image}
              alt={it.caption || `gallery ${i + 1}`}
              className="w-full aspect-[4/3] object-cover"
            />
            <div className="p-3 space-y-2">
              <Input
                placeholder="Caption (optional)"
                value={it.caption || ""}
                onChange={(e) => updateCaption(i, e.target.value)}
                className={inputCls}
              />
              <button
                type="button"
                onClick={() => remove(i)}
                data-testid={`admin-delete-gallery-${i}`}
                className="text-[#5C636A] hover:text-red-600 inline-flex items-center gap-1 text-xs uppercase tracking-wider"
              >
                <Trash2 className="w-3.5 h-3.5" /> Remove
              </button>
            </div>
          </div>
        ))}
        {list.length === 0 && (
          <div className="col-span-full text-sm text-[#5C636A] italic py-6 text-center border border-dashed border-[#E5DFD3]">
            No photos yet. Click <strong>Upload photo(s)</strong> above to add.
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleryEditor;
